import React from "react";
export default () => (
  <div className="mt-5 flex flex-col md:flex-row items-center md:justify-around gap-4 md:gap-0">
    <div className="flex flex-col">
      <div className="App-Logo flex justify-center md:justify-end">
        <a href="https://fomo-score.com">
          <img className="h-20 md:h-24" src="./logo.png" alt="fomo-score.com" />
        </a>
      </div>
    </div>
    <div className="flex flex-row md:flex-col justify-center gap-3">
      <a
        href="https://apps.apple.com/us/app/fomo-score/id6446705709"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img className="h-8 md:h-10" alt="app store" src="./apple-badge.png" />
      </a>
      <a
        href="https://play.google.com/store/apps/details?id=com.fomoscore.app"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          className="h-8 md:h-10"
          alt="google play"
          src="./google-badge.png"
        />
      </a>
    </div>
  </div>
);
